module.exports = __webpack_public_path__ + "static/img/hussar_recommendations_face.fc6cc78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentPage/hussar_recommendations_face.png
// module id = a8eh
// module chunks = 0